module.exports = __webpack_public_path__ + "img/o-face.7aaef10e.png";